import { apiClient } from "./api_base";
import { normalizeGtin } from "../utils/gtin";

// Search products by name (max 10). Empty query returns [].
export const searchProducts = async (query, limit) => {
  const effectiveLimit = typeof limit === 'number' ? limit : 10;
  const params = { limit: effectiveLimit };
  if (typeof query === 'string' && query.trim().length > 0) {
    params.query = query.trim();
  }
  const response = await apiClient.get('/products', { params });
  return response;
};

// Fetch a single product by GTIN or C-GTIN (numeric codes are left-padded to 14)
export const fetchProductByGtin = async (gtin) => {
  const normalized = normalizeGtin(gtin);
  if (!normalized) {
    const err = new Error('Ogiltig GTIN');
    err.response = { data: { error: 'Ogiltig GTIN' }, status: 422 };
    throw err;
  }
  const response = await apiClient.get('/products/by-gtin', { params: { gtin: normalized } });
  return response;
};

// Menuwise-eligible similar products (Meili filters + sort)
export const fetchSimilarProducts = async (productId, options = {}) => {
  const params = { limit: options.limit ?? 40 };
  if (typeof options.q === 'string' && options.q.trim()) {
    params.q = options.q.trim();
  }
  if (options.sameBrand) params.same_brand = 1;
  if (options.eco) params.eco = 1;
  if (options.sameCountry) params.same_country = 1;
  if (typeof options.country === 'string' && /^[a-z]{2}$/i.test(options.country.trim())) {
    params.country = options.country.trim().toLowerCase();
  }
  if (typeof options.sort === 'string' && options.sort && options.sort !== 'relevance') {
    params.sort = options.sort;
  }
  const response = await apiClient.get(`/products/${productId}/similar`, { params });
  return response;
};
